import React, { useState } from 'react';
import { createDialog, DialogProps, openDialog } from '../dialogs/dialogs';
import { nuiCtx } from '../../common/initialization';
import { Button } from '../button/Button';
import SuccessIcon from '../../icons/SuccessIcon';
import NegativeIcon from '../../icons/NegativeIcon';
import i18n from '../../common/i18n';
import axios from 'axios';

import './SendGridCard.less';
import clsx from 'clsx';
import { dispatch } from 'nike-re-framejs';
import { start2FA } from '../2fa/views/Wizard2FA';

export default function SendGridCard() {
    const [disable, setDisable] = useState(false);

    const onClick = () => {
        sendGridCardRequest()
            .catch(error => {
                if ((error.response.status = 403 && error?.response?.data?.code === 'AUTH_REQUIRED_2FA')) {
                    const sendGridCallback = token => sendGridCardRequest(token);
                    dispatch(start2FA(null, error.response.data.methods, 'GRID', null, sendGridCallback));
                    return Promise.resolve();
                } else {
                    return openDialog(GridSendResultDialog, { success: false });
                }
            })
            .finally(() => setDisable(false));
        setDisable(true);
    };
    return (
        <Button
            primary
            onClick={onClick}
            disabled={disable}
            label={i18n('nui.profileSettings.sendGridSubmit')}
            className="profile-settings-narrow-button-temp mt-20"
            dataAtid="button-send-grid-card"
        />
    );
}

export function sendGridCardRequest(token2Fa?: string) {
    return axios
        .post(
            '/api/customer/send-grid-card',
            { token2Fa: token2Fa },
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        )
        .then(() => openDialog(GridSendResultDialog, { success: true }));
}

const GridSendResultDialog = createDialog({
    name: 'nui-grid-send-result-dialog',
    component: ({ success, close }: { success?: boolean } & DialogProps) => {
        const { NuiDialog } = nuiCtx.components;
        return (
            <NuiDialog
                name="nui-grid-send-result-dialog"
                className={clsx({ 'send-grid-card-result-dialog-portal': nuiCtx.platform === 'portal' })}
            >
                <div className="send-grid-card-result-dialog-content">
                    <div className="text-center mt-30">
                        {success ? <SuccessIcon width={70} height={70} /> : <NegativeIcon width={70} height={70} />}
                    </div>
                    <h1 className="text-center uppercase fs-18 py-20">
                        {success
                            ? i18n('nui.profileSettings.sendGrid.success')
                            : i18n('nui.profileSettings.sendGrid.failure')}
                    </h1>
                    <div className="text-center fs-14 c-black-50-2 pb-20">
                        {success
                            ? i18n('nui.profileSettings.sendGrid.success.detail')
                            : i18n('nui.profileSettings.sendGrid.failure.detail')}
                    </div>
                    <Button
                        onClick={close}
                        primary
                        large
                        className="nui-button full-width mt-30"
                        label={i18n('nui.button.close')}
                        dataAtid="button-send-grid-result-close"
                    />
                </div>
            </NuiDialog>
        );
    }
});
